import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../redux/redux.hook";
import { getCallStart } from "./callStart.thunk";
import { resetCallStart } from "./callStart.slice";
import { isLoading, isSuccess, isError, isIdle } from "@/app/utils/asyncStatus";

const useCallStart = () => {
  const dispatch = useAppDispatch();
  const { data, status, error } = useAppSelector((state) => state.callStart);

  const fetchCallStart = useCallback(() => {
    dispatch(getCallStart());
  }, [dispatch]);

  const clearCallStart = useCallback(() => {
    dispatch(resetCallStart());
  }, [dispatch]);

  return {
    data,
    status,
    error,
    isIdle: isIdle(status),
    isLoading: isLoading(status),
    isSuccess: isSuccess(status),
    isError: isError(status),
    fetchCallStart,
    clearCallStart,
  };
};

export default useCallStart;